import CryptoJS from "crypto-js";
const key = process.env.REACT_APP_KEY;

export const Encryption = (data) => {
  let encryptCiphertext = CryptoJS.AES.encrypt(data, key); // Encryption Part
  return encryptCiphertext;
};
